export default "__VITE_ASSET__GHYdWEqX__"